







































































import {Component, Mixins, Prop} from "vue-property-decorator";
import XForm from "@/components/SimpleForm.vue";
import { paymentForm } from "@/assets/scripts/form-fields/main";
import {validationMixin} from "vuelidate";
import AppApiMixin from "@/components/mixins/AppApi.vue";
import {mapGetters, mapState} from "vuex";
import {tr} from "date-fns/locale";
import moment from "moment";
import {required} from "@/assets/scripts/form-fields/field-rules";

const { values, attrs, validations, errors } = paymentForm;

@Component({
  components: {
    XForm,
  },
  computed: {
    ...mapState({ appEnviroment: "appEnviroment" }),
    ...mapGetters({
      contractId: "contract/id",
    }),
  },
  mixins: [validationMixin],
  validations,
})
class PaymentCard extends Mixins(AppApiMixin, XForm) {
  [x: string]: any

  @Prop({ default: false }) readonly lockAmount!: boolean;

  values = values
  defaultValues: {[x: string]: any} = {}
  allFieldAttrs = { ...attrs };

  useSubmitButtonLoading = false;
  submitSuccess = '';
  submitError = "";

  monthsList = [];

  loaded = false

  async mounted() {
    this.values = {...this.values, ...this.$attrs};
    this.defaultValues = {...this.values, ...this.$attrs};
    if (this.lockAmount) {
      this.allFieldAttrs = {
        ...this.allFieldAttrs,
        amount: { ...this.allFieldAttrs.amount, valuesInputDisabled: true },
      };
    }

    if(this.defaultValues.docs != ""){
      delete this.allFieldAttrs['period']
      this.loaded = true
      return
    }

    this.allFieldAttrs['period'] = {
      type: "text",
      label: "Период оплаты",
      required: false
    }

    let data = await this.getPeriodsPaymentURL(this.contractId)
    data = data.reverse()

    this.monthsList = data.map(item => item['месяц'])
    this.values['period'] = this.monthsList[0];
    this.loaded = true
  }

  makeDate(date) {
    return moment(date).locale('ru').format('MMMM YYYY')
  }

  async submitForm() {
    this.useSuccessAlert = false
    this.useSubmitButtonLoading = true

    const formData = new FormData
    for (let key in this.values) {
      formData.append(key, this.values[key]);
    }

    formData.append('contractId', this.contractId);
    formData.append('paymentMode', this.lockAmount ? 'all' : 'single');
    // formData.append('author', this.temp_mas[0]);

    try {
      const data = await this.getPaymentURL(formData)

      if (data && data.result && (data.url) != 0) {
        window.location.href = data.url;
      }
    } catch (e) {
      console.log('error', e);
      this.submitError = e.data;
    }

    this.submitSuccess = '';
    this.useSubmitButtonLoading = false
  }

  changeAmount() {
    const { appEnviroment } = this;
    this.values['total'] = this.values['amount'] + (this.values['amount'] * (+appEnviroment.constants["PaymentFee"] || 0));
  }
}

export default PaymentCard;
